<template>
  <div style="height: 100%;width: 100%;border-bottom: #d5d6d3 solid 1px;">
    <div class="navcontainer _navcontainer" @mouseover="subTitleShow = false" :class="{ 'sticky-nav': isSticky }">
      <div class="appleicon _appleicon" @click="$router.push('/home')" style="margin-left:20px">
        <img v-if="this.$i18n.locale == 'zh'" src="../../assets/logo/logo.png" alt="Logo" width="100%">
        <img v-if="this.$i18n.locale == 'en'" src="../../assets/logo/logo.png" alt="Logo" width="100%">
      </div>
      <div  class="sousuo-phone">
        <i class="iconfont icon-sousuo1" @click="openSousuoPhone('sousuo')" style="font-size: 2em"></i>
      </div>
      <div class="navicon _navicon"><i class="iconfont icon-caidan" @click="opencaidan()"></i></div>
      <div id="navID" class="mainnavlist _mainnavlist">
        <div class="navlistclose"><i @click="closecaidan()" class="iconfont icon-guanbi"></i></div>
        <div :style="this.$i18n.locale=='zh'?'font-size:2vh!important':'font-size:1.75vh'"
             @mouseleave="hovering1 = false"
             @click="activeRouterClick($t('home.aboutus'))"
             :class="activeRouter == $t('home.aboutus')?'activeDiv':'notActiveDiv'" :id="$t('home.aboutus')">
          {{ $t('home.aboutUs')}}
          <span v-if="hasSubmenu($t('home.aboutus'))" class="dropdown-arrow"></span>
        </div>
        <div :style="this.$i18n.locale=='zh'?'font-size:2vh!important':'font-size:1.75vh'"
             @mouseleave="hovering2 = false"
             @click="activeRouterClick($t('home.activities'))" @mouseover.stop="hovering2 = true;openDropdown($t('home.activities'))"
             :class="activeRouter == $t('home.activities')?'activeDiv':'notActiveDiv'" :id="$t('home.activities')">
          {{ $t('home.wantWeDo') }}
          <span v-if="hasSubmenu($t('home.activities'))" class="dropdown-arrow"> </span>
        </div>
        <div :style="this.$i18n.locale=='zh'?'font-size:2vh!important':'font-size:1.75vh'"
             @click="routerpush('/partners');" @mouseover="showDropdown = false"
             :class="activeRouter == '/partners'?'activeDiv':'notActiveDiv'">{{ $t('home.partners') }}
        </div>
        <div :style="this.$i18n.locale=='zh'?'font-size:2vh!important':'font-size:1.75vh'"
             @mouseleave="hovering3 = false"
             @click="activeRouterClick($t('home.downResource'));activeRouter =$t('home.downResource')"
             @mouseover.stop="hovering3 = true;openDropdown($t('home.downResource'))"
             :class="activeRouter == $t('home.downResource')?'activeDiv':'notActiveDiv'" :id="$t('home.downResource')">
          {{ $t('home.resource') }}
          <span v-if="hasSubmenu($t('home.downResource'))" class="dropdown-arrow"> </span>
        </div>
<!--        <div :style="this.$i18n.locale=='zh'?'font-size:2vh!important':'font-size:1.75vh'"-->
<!--             @mouseover="showDropdown = false" :class="activeRouter == '/elearning'?'activeDiv':'notActiveDiv'">-->
<!--          {{ $t('home.eLearning') }}-->
<!--        </div>-->
        <div :style="this.$i18n.locale=='zh'?'font-size:2vh!important':'font-size:1.75vh'"
             @click="routerpush('/contact');" @mouseover="showDropdown = false"
             :class="activeRouter == '/contact'?'activeDiv':'notActiveDiv'">{{ $t('home.contact') }}
        </div>

      </div>
      <div class="nav-actions">
        <div class="sousuo">
          <i class="iconfont icon-sousuo1" @click="openDropdown('sousuo')" style="font-size: 1.6em;cursor: pointer;"></i>
        </div>
        <div class="language-dropdown-container">
          <div class="languageButBox-effect language-selector" @click="toggleLanguageDropdown">
            <span class="language-icon">
              <svg t="1743312401136" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4641" width="18" height="18"><path d="M757.205333 473.173333c5.333333 0 10.453333 2.090667 14.250667 5.717334a19.029333 19.029333 0 0 1 5.888 13.738666v58.154667h141.184c11.093333 0 20.138667 8.704 20.138667 19.413333v232.704a19.797333 19.797333 0 0 1-20.138667 19.413334h-141.184v96.981333a19.754667 19.754667 0 0 1-20.138667 19.370667H716.8a20.565333 20.565333 0 0 1-14.250667-5.674667 19.029333 19.029333 0 0 1-5.888-13.696v-96.981333h-141.141333a20.565333 20.565333 0 0 1-14.250667-5.674667 19.029333 19.029333 0 0 1-5.930666-13.738667v-232.704c0-5.12 2.133333-10.112 5.930666-13.738666a20.565333 20.565333 0 0 1 14.250667-5.674667h141.141333v-58.154667c0-5.162667 2.133333-10.112 5.888-13.738666a20.565333 20.565333 0 0 1 14.250667-5.674667h40.362667zM192.597333 628.394667c22.272 0 40.32 17.365333 40.32 38.826666v38.741334c0 40.618667 32.512 74.368 74.624 77.397333l6.058667 0.213333h80.64c21.930667 0.469333 39.424 17.706667 39.424 38.784 0 21.077333-17.493333 38.314667-39.424 38.784H313.6c-89.088 0-161.28-69.461333-161.28-155.178666v-38.741334c0-21.461333 18.005333-38.826667 40.277333-38.826666z m504.106667 0h-80.64v116.394666h80.64v-116.394666z m161.28 0h-80.64v116.394666h80.64v-116.394666zM320.170667 85.333333c8.234667 0 15.658667 4.778667 18.773333 12.202667H338.773333l161.322667 387.84c2.517333 5.973333 1.706667 12.8-2.005333 18.090667a20.394667 20.394667 0 0 1-16.725334 8.533333h-43.52a20.181333 20.181333 0 0 1-18.688-12.202667L375.850667 395.648H210.901333l-43.264 104.149333A20.181333 20.181333 0 0 1 148.906667 512H105.514667a20.394667 20.394667 0 0 1-16.725334-8.533333 18.773333 18.773333 0 0 1-2.005333-18.090667l161.28-387.84A20.181333 20.181333 0 0 1 266.88 85.333333h53.290667zM716.8 162.901333c42.794667 0 83.84 16.341333 114.090667 45.44a152.234667 152.234667 0 0 1 47.232 109.738667v38.741333c-0.469333 21.077333-18.389333 37.930667-40.32 37.930667s-39.808-16.853333-40.32-37.930667v-38.741333c0-20.608-8.490667-40.32-23.637334-54.869333a82.304 82.304 0 0 0-57.045333-22.741334h-80.64c-21.888-0.469333-39.424-17.706667-39.424-38.784 0-21.077333 17.493333-38.314667 39.424-38.784h80.64z m-423.424 34.304L243.2 318.037333h100.48L293.418667 197.205333z" fill="#000000" p-id="4642"></path></svg>
            </span>
            <span class="language-text" v-if="this.$i18n.locale == 'en'">English</span>
            <span class="language-text" v-else>简体中文</span>
            <span class="dropdown-arrow" :class="{'dropdown-arrow-open': showLanguageDropdown}">▼</span>
          </div>
          <div v-show="showLanguageDropdown" class="language-dropdown-menu">
            <div class="language-option" @click="selectLanguage('zh')">
              简体中文
            </div>
            <div class="language-option" @click="selectLanguage('en')">
              English
            </div>
            <!-- 未来可以在这里添加更多语言选项 -->
            <!-- <div class="language-option" @click="selectLanguage('es')">Español</div> -->
            <!-- <div class="language-option" @click="selectLanguage('fr')">Français</div> -->
          </div>
        </div>
      </div>
      <!-- <div class="shopcar">
        <button class="but" style="">中文</button>
      </div> -->
      <!-- <div v-show="activeRouter !== '/home'" style="margin-left:0px"><iframe width="200" height="25" frameborder="0" scrolling="no" hspace="0" src="https://i.tianqi.com/?c=code&a=getcode&id=15&icon=1"></iframe></div> -->
      <div :class="sousuoShow==true?'dropdown':'dropdown2'" v-if="showDropdown" @mouseover="subTitleShow = false"
           :style="sousuoShow==true?{}:{'top':divtop + 'px'}">
        <div v-if="sousuoShow" class="sousuo-box" @mouseleave="showDropdown = false">
          <div class="sousuo-input">
            <i class="iconfont icon-sousuo" style="font-size: 25px"></i>
            <input type="text" class="search-input" v-model="search" @keyup="checkKey"
                   :placeholder="$t('home.placeholder')" style="height: 35px">
          </div>
          <div class="sousuo-list">
            <p>{{ $t('home.recommondedSearch') }}</p>
            <p>{{ $t('home.content1') }}</p>
            <p>{{ $t('home.content2') }}</p>
            <p>{{ $t('home.content3') }}</p>
          </div>


        </div>
        <div v-if="subTitleShow" class="aboutUs-box" :style="{'margin-left':divleft+'px'}"
             @mouseover.stop="subTitleShow = true" @mouseleave="showDropdown = false">
          <!--<div class="subTitle">
            {{subTitleList.title}}
          </div>-->
          <div class="subTitle-list">
            <p v-for="(item,index) in subTitleList.children" :key="index"
               @click="activeRouterClick2(subTitleList.title,index)">{{ item.title }}</p>
          </div>
        </div>
      </div>
<!--      <el-drawer-->
<!--        class="sousuo-drawer"-->
<!--        title="查询"-->
<!--        :visible.sync="sousuoShowPhone"-->
<!--        direction="rtl"-->
<!--        size="100%"-->
<!--        >-->
<!--        <span>我来啦!</span>-->
<!--      </el-drawer>-->
    </div>
  </div>
</template>

<script>

import {getNavTopTree} from "@/api/navtop";
import cookie from 'js-cookie'
import axios from 'axios';

export default {
  name: 'navtop',
  components: {},
  inject: ['reload'],
  data() {
    return {
      nalistshowflag: false,
      showDropdown: false,
      sousuoShow: false,
      sousuoShowPhone: false,
      homeShow: true,
      activeHandleResizeName: "",//当前下拉菜单名称，用于避免下拉菜单出现时位置变化
      activeRouter: '',
      search: '',
      hovering1:false,
      hovering2:false,
      hovering3:false,
      param: {
        id: "",
        pid: "",
      },
      id: "",
      pid: "",
      subTitleShow: false,
      subTitleList: {},
      divleft: '100',
      divleft2: '100',
      divtop: '100',
      titleTree: [],
      aboutUsList: [
        {
          name: 'ORGANIZATION STRUCTURE'
        },
        {
          name: 'NAME & LOGO'
        },
        {
          name: 'HISTORY'
        },

      ],
      whatWeDoList: [
        {
          name: 'JOINT ACTION'
        },
        {
          name: 'JOINT PATROL'
        },
        {
          name: 'CAPACITY BUILDING'
        },
        {
          name: 'SCHOLARSHIP'
        },
        {
          name: 'ACADEMY'
        },
        {
          name: 'INTEGRATED COORDINATION & OPERATIONAL SUPPORT'
        },
      ],
      moveType: false,
      languages: "",
      isSticky: false,
      showLanguageDropdown: false,
    }
  },
  created() {
    // this.getLocation()
    if (this.$i18n.locale == 'zh') {
      this.languages = '中文';
    } else {
      this.languages = 'ENGLISH';
    }
  },
  mounted() {
    this.getNavTopTree()
    //监听分辨率变化，避免下拉菜单位置变化
    let that = this
    window.addEventListener('resize', function () {
      if (that.activeHandleResizeName != "") {
        that.handleResize2(that.activeHandleResizeName);
        that.handleResize3(that.activeHandleResizeName)
      }
    })
    // Add scroll event listener for sticky navigation
    window.addEventListener('scroll', this.handleScroll)

    // Add click outside listener
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    // window.removeEventListener('resize',this.handleResize)
    let that = this
    window.removeEventListener('resize', function () {
      if (that.activeHandleResizeName != "") {
        that.handleResize2(that.activeHandleResizeName);
        that.handleResize3(that.activeHandleResizeName)
      }
    })
    window.removeEventListener('scroll', this.handleScroll)

    // Remove click outside listener
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    getLocation() {
      axios.get('https://ipapi.co/json/')
        .then(response => {
          let isInternational = response.data.country_name !== 'China';
          if (isInternational == false) {
            cookie.set("lang", 'zh')
            // this.langToggle()
          } else {
            cookie.set("lang", 'en')
            this.langToggle()
          }
          // this.langToggle()
        })
        .catch(error => {
          console.error('无法获取地理位置信息:', error);
        });
    },
    langToggle() {
      if (this.$i18n.locale == 'zh') {
        this.$i18n.locale = 'en';
        cookie.set("lang", 'en')
        window.location.reload();
        this.getNavTopTree()
      } else {
        this.$i18n.locale = 'zh';
        cookie.set("lang", 'zh')
        this.getNavTopTree()
        window.location.reload();
      }
    },
    getNavTopTree() {
      getNavTopTree().then(res => {
        this.titleTree = res.data[0]
        sessionStorage.setItem('titleTree', JSON.stringify(this.titleTree))
      })
    },
    activeRouterClick(title) {
      this.activeRouter = title
      if (title == "关于中心" || title == "About us") {
        this.$router.push({
          path: '/summary',
        })
      } else if(title == "资源分享" || title == "Download Resouces"){
        this.param.pid = ""  //一级菜单id
        this.param.id = ""  //二级菜单id
        this.titleTree.children.forEach((item, index) => {
          if (item.title == title) {
            this.param.id = item.data.id
            this.param.pid = item.data.columnPid
          }
        });
        this.$router.push({
          path: '/cardNavigation',
          query: {
            pid: this.param.pid,
            id: this.param.id,
          }
        })
      }
      else {
        this.param.pid = ""  //一级菜单id
        this.param.id = ""  //二级菜单id
        this.titleTree.children.forEach((item, index) => {
          if (item.title == title) {
            this.param.id = item.data.id
            this.param.pid = item.data.columnPid
          }
        });
        this.$router.push({
          path: '/navigation',
          query: {
            pid: this.param.pid,
            id: this.param.id,
          }
        })
      }

    },
    onMouseMove(n) {
      if (n == 1) {
        this.moveType = true
      } else {
        this.moveType = false
      }
    },
    onMouseLeaves() {
      if (this.moveType == false) {
        this.subTitleShow = false
      }
    },
    activeRouterClick2(title, index) {
      console.log("index",index)
      this.activeRouter = title
      this.param.pid = ""  //二级菜单id
      this.param.id = ""  //三级菜单id
      this.param.pid = this.subTitleList.children[index].data.columnPid
      this.param.id = this.subTitleList.children[index].data.id
      /*if(title=='总述' || title=='组织架构' || title=='名字和标志' || title=='秘书长简介'
        || title=='Organizational Structure' || title=='Name and LOGO' || title=='Summary' || title=='LEADERSHIP'){*/
      if (title == "关于中心" || title == "About us") {
        this.$router.push({
          path: '/summary',
          query: {
            index: index,
          }
        })
      } else if(title == "资源分享"&&index===1||title == "资源分享"&&index===0 || title == "Download Resouces"&&index===1||title == "Download Resouces"&&index===0){
        this.$router.push({
          path: '/cardNavigation',
          query: {
            pid: this.param.pid,
            id: this.param.id,
            // isThirdLevel: true,
          }
        })
      }
      else {
        this.$router.push({
          path: '/navigation',
          query: {
            pid: this.param.pid,
            id: this.param.id,
            // isThirdLevel: true,
          }
        })
      }


    },
    handleResize() {
      // if(this.subTitleShow == "aboutUs"){
      // 假设你有一个元素的ID是'myElement'
      const element = document.getElementById('aboutUs');

      // 获取元素的左上角相对于视口的位置
      const rect = element.getBoundingClientRect();

      // 获取元素的左边界距离视口左边界的距离
      const offsetWidthFromLeft = rect.left;
      // let height = this.$refs.videoPlayerBox.offsetHeight
      this.divleft = offsetWidthFromLeft
      // }else if(this.subTitleShow == "whatWeDo"){
      // 假设你有一个元素的ID是'myElement'
      const element2 = document.getElementById('whatWeDo');

      // 获取元素的左上角相对于视口的位置
      const rect2 = element2.getBoundingClientRect();

      // 获取元素的左边界距离视口左边界的距离
      const offsetWidthFromLeft2 = rect2.left;
      // let height = this.$refs.videoPlayerBox.offsetHeight
      this.divleft2 = offsetWidthFromLeft2
      // }

    },
    //监测菜单左偏移
    handleResize2(name) {
      if (name != "") {
        this.activeHandleResizeName = name
        // if(this.subTitleShow == "aboutUs"){
        // 假设你有一个元素的ID是'myElement'
        const element = document.getElementById(name);
        // 获取元素的左上角相对于视口的位置
        const rect = element.getBoundingClientRect();
        // 获取元素的左边界距离视口左边界的距离
        const offsetWidthFromLeft = rect.left;
        // let height = this.$refs.videoPlayerBox.offsetHeight
        this.divleft = offsetWidthFromLeft
      }

    },
    //监测菜单上偏移
    handleResize3(name) {
      // 假设你有一个元素的ID是'myElement'
      const element = document.getElementById(name);
      // 获取元素的左上角相对于视口的位置
      const rect = element.getBoundingClientRect();
      // 获取元素的左边界距离视口左边界的距离
      const offsetWidthFromTop = rect.top;
      // let height = this.$refs.videoPlayerBox.offsetHeight
      const height = element.clientHeight
      this.divtop = offsetWidthFromTop + height

    },
    home() {
      this.homeShow = false
    },
    routerpush(to) {
      this.$router.push(to)
      // this.showDropdown = true
      // 跳转之后，记得关闭菜单（在屏幕宽度小于800的时候才生效）
      var dom = document.getElementById('navID')
      if (dom.classList.contains('navlistshow')) {
        dom.classList.remove('navlistshow')
      }
    },
    openDropdown(name) {
      this.sousuoShow = false
      this.showDropdown = true
      this.subTitleShow = false
      if (name === 'sousuo') {
        // this.sousuoShow = true   // 显示下拉菜单，现在不要了，直接跳到查询页面
        this.$router.push({
          path: '/search',
          query: {
            key: this.search,
          }
        })
      } else {
        this.subTitleShow = true
        this.handleResize2(name)
        this.handleResize3(name)
        if (this.titleTree.children != null && this.titleTree.children.length > 0) {
          this.titleTree.children.forEach((item, index) => {
            if (item.title == name) {
              this.subTitleList = item
            }
          });
        }

      }
    },
    checkKey(event) {
      if (event.key === 'Enter') {
        this.$router.push({
          path: '/search',
          query: {
            key: this.search,
          }
        })
      }
    },
    handleMouseEnter(event) {
      console.log("event.currentTarget", event)
      // 检查事件的目标是否是父元素本身
      // if (event.currentTarget === event.target) {
      //   console.log('鼠标进入了父元素，但未进入子元素');
      // }
    },
    // 当屏幕宽度小于800的时候，点击菜单图标，显示隐藏的菜单
    opencaidan() {
      var dom = document.getElementById('navID')

      if (dom.classList.contains('navlistshow')) {
        return
      }
      dom.classList.add('navlistshow')
    },
    // 当屏幕宽度小于800的时候，点击关闭按钮， 关闭菜单
    closecaidan() {
      var dom = document.getElementById('navID')
      if (dom.classList.contains('navlistshow')) {
        dom.classList.remove('navlistshow')
      }
    },
    openSousuoPhone() {
      this.sousuoShowPhone = true
      this.$router.push({
        path: '/search',
        query: {
          key: this.search,
        }
      })
    },
    // Check if a menu item has submenus
    hasSubmenu(title) {
      if (!this.titleTree || !this.titleTree.children) return false

      const menuItem = this.titleTree.children.find(item => item.title === title)
      return menuItem && menuItem.children && menuItem.children.length > 0
    },

    // Handle scroll event for sticky navigation
    handleScroll() {
      const scrollPosition = window.scrollY
      this.isSticky = scrollPosition > 0
    },
    toggleLanguageDropdown() {
      this.showLanguageDropdown = !this.showLanguageDropdown;
    },
    selectLanguage(locale) {
      if (this.$i18n.locale !== locale) {
        this.langToggle(); // 使用现有的语言切换方法，保持行为一致
      }
      this.showLanguageDropdown = false;
    },
    handleClickOutside(event) {
      const container = document.querySelector('.language-dropdown-container');
      if (container && !container.contains(event.target)) {
        this.showLanguageDropdown = false;
      }
    }
  }
}
</script>

<style lang="less" scoped>
/* ====== 桌面端样式 (大于800px) ====== */
@media only screen and (min-width: 800px) {
  .navcontainer {
    top: 0;
    display: flex;
    align-items: center;
    height: 10vh;
    min-height: 70px;
    max-height: 90px;
    background-color: rgb(255, 255, 255);
    color: #333333;
    padding: 0 2vw;
    justify-content: space-between;
    position: relative;

    .navicon {
      display: none;
      cursor: pointer;
    }

    .navicon:hover {
      color: #111111;
    }

    .appleicon {
      width: 15%;
      min-width: 120px;
      max-width: 180px;
      cursor: pointer;
      display: flex;
    }

    .appleicon:hover {
      color: #111111;
    }

    .mainnavlist {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      width: 70%;
      gap: 3.5vw;
      max-gap: 50px;
      margin: 0;

      .navlistclose {
        display: none;
      }

      div {
        text-align: center;
        white-space: nowrap;
        cursor: pointer;
        font-size: clamp(14px, 1.8vh, 18px);
        font-weight: 600;
        font-family: SourceHanSansCN, SourceHanSansCN;
        padding: 0.5rem 0;
        transition: color 0.3s ease;
      }

      div:hover {
        color: #00AEEF;
      }


    }

    .nav-actions {
      display: flex;
      align-items: center;
      gap: 1.5rem;
      min-width: 140px;
      justify-content: flex-end;
    }

    .sousuo {
      i {
        transition: color 0.3s ease;
        color: #333333;
        
        &:hover {
          color: #00AEEF;
        }
      }
    }

    .languageButBox-effect {
      transition: color 0.3s ease;
    }

    .languageButBox-effect:hover {
      color: #626360 !important;
    }

    .shopcar {
      width: 100px;
      cursor: pointer;
    }

    .shopcar:hover {
      color: #111111;
    }

    .but {
      width: 72px;
      height: 24px;
      border-radius: 8px;
      border: 1px solid #333333;
      background-color: rgba(255, 255, 255, 0);
    }

    .Logo-title {
      font-family: SourceHanSansCN, SourceHanSansCN;
      font-weight: 500;
      font-size: 28px;
      color: #333333;
      line-height: 42px;
      text-align: left;
      font-style: normal;
      margin-left: 10px;
    }

    .dropdown {
      position: absolute;
      top: 10vh;
      left: 0;
      width: 100%;
      background-color: rgb(255, 255, 255);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      z-index: 1000;
      display: flex;

      .sousuo-box {
        //display: flex;
        //align-items: center;
        //justify-content: center;
        height: 100%;
        width: 400px;
        margin-left: 20%;

        .sousuo-input {
          position: relative;
          display: inline-block;
          align-items: center; /* 注意：align-items 在 inline-block 或 block 级别元素上通常不起作用，这里主要是为了说明意图 */
        }

        .sousuo-input i {
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          font-size: 30px;
          color: #706e6e;
        }

        .sousuo-input input {
          height: 40px;
          border: 1px solid transparent; /* 设置为透明边框 */
          padding-left: 30px; /* 为图标留出空间 */
          /* 可以添加更多样式，如圆角等 */
          border-radius: 4px; /* 示例：添加圆角边框 */
        }

        .search-input {
          height: 45px;
          border: 1px solid transparent; /* 初始边框设置为透明 */
          padding-left: 40px; /* 根据图标大小调整 */
          /* 移除焦点时的边框 */
          outline: none; /* 移除浏览器默认的焦点轮廓 */
          box-shadow: none; /* 防止某些浏览器在获得焦点时添加阴影 */
          font-size: 20px;

        }

        .sousuo-list {
          line-height: 30px;
          color: #999;
          cursor: pointer;
          margin-top: 10px;
          margin-left: 15%;

          p {
            text-align: left; /* 确保文字左对齐 */
            padding-left: 10px; /* 可选：增加左边距，让文本与输入框保持一致 */
            font-size: 13px; /* 可选：调整字体大小，使其与设计匹配 */
            margin: 0; /* 清除默认的外边距 */
          }
        }


      }

      .aboutUs-box {
        background-color: #ffffff;
        padding: 1rem 1.5rem;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

        .subTitle-list {
          color: #999;
          cursor: pointer;

          p {
            text-align: left;
            font-size: clamp(14px, 1.8vh, 18px);
            margin: 0;
            font-family: SourceHanSansCN-Medium;
            font-weight: 600;
            line-height: 2.5rem;
            padding: 0.5rem 1rem;
            border-radius: 6px;
            transition: all 0.3s ease;
          }

          p:hover {
            color: white;
            background-color: #00AEEF;
            transform: translateX(5px);
          }
        }
      }

      .whatWeDo-box {
        height: 100%;
        width: 400px;
        margin-left: 20%;

        .subTitle {
          color: rgba(110, 110, 115, 1);
          font-size: 16px;
          font-family: SourceHanSansCN-Regular;
          font-weight: normal;
          text-align: left;
          line-height: 24px;
          margin-left: 12.5%;
        }

        .subTitle-list {
          line-height: 30px;
          color: #999;
          cursor: pointer;
          margin-left: 12.5%;

          p {
            text-align: left; /* 确保文字左对齐 */
            // padding-left: 10px; /* 可选：增加左边距，让文本与输入框保持一致 */
            font-size: 16px; /* 可选：调整字体大小，使其与设计匹配 */
            margin: 0; /* 清除默认的外边距 */
            font-family: SourceHanSansCN-Medium;
            font-weight: 600;
            line-height: 36px;
          }

          p:hover {
            text-align: left; /* 确保文字左对齐 */
            // padding-left: 10px; /* 可选：增加左边距，让文本与输入框保持一致 */
            font-size: 16px; /* 可选：调整字体大小，使其与设计匹配 */
            margin: 0; /* 清除默认的外边距 */
            color: rgba(0, 112, 255, 1);
            font-family: SourceHanSansCN-Medium;
            font-weight: 600;
            line-height: 36px;
          }
        }
      }
    }

    .dropdown2 {
      //display: none;
      position: absolute;
      // top: 11vh;
      left: 0;
      width: 100%;
      // height: 220px;
      // background-color: rgb(255, 255, 255);
      z-index: 1000;
      display: flex;

      .sousuo-box {
        //display: flex;
        //align-items: center;
        //justify-content: center;
        height: 100%;
        width: 400px;
        margin-left: 20%;
        padding-top: 5%;

        .sousuo-input {
          position: relative;
          display: inline-block;
          align-items: center; /* 注意：align-items 在 inline-block 或 block 级别元素上通常不起作用，这里主要是为了说明意图 */
        }

        .sousuo-input i {
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          font-size: 30px;
          color: #706e6e;
        }

        .sousuo-input input {
          height: 40px;
          border: 1px solid transparent; /* 设置为透明边框 */
          padding-left: 30px; /* 为图标留出空间 */
          /* 可以添加更多样式，如圆角等 */
          border-radius: 4px; /* 示例：添加圆角边框 */
        }

        .search-input {
          height: 45px;
          border: 1px solid transparent; /* 初始边框设置为透明 */
          padding-left: 40px; /* 根据图标大小调整 */
          /* 移除焦点时的边框 */
          outline: none; /* 移除浏览器默认的焦点轮廓 */
          box-shadow: none; /* 防止某些浏览器在获得焦点时添加阴影 */
          font-size: 20px;

        }

        .sousuo-list {
          line-height: 30px;
          color: #999;
          cursor: pointer;
          margin-top: 10px;
          margin-left: 15%;

          p {
            text-align: left; /* 确保文字左对齐 */
            padding-left: 10px; /* 可选：增加左边距，让文本与输入框保持一致 */
            font-size: 13px; /* 可选：调整字体大小，使其与设计匹配 */
            margin: 0; /* 清除默认的外边距 */
          }
        }


      }

      .aboutUs-box {
        background-color: rgb(255, 255, 255);
        padding: 1rem 1.5rem;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

        .subTitle-list {
          color: #999;
          cursor: pointer;

          p {
            text-align: left;
            font-size: clamp(14px, 1.8vh, 18px);
            margin: 0;
            font-family: SourceHanSansCN-Medium;
            font-weight: 600;
            line-height: 2.5rem;
            padding: 0.5rem 1rem;
            border-radius: 6px;
            transition: all 0.3s ease;
          }

          p:hover {
            color: white;
            background-color: #00AEEF;
            transform: translateX(5px);
          }
        }
      }

      .whatWeDo-box {
        height: 100%;
        width: 400px;
        margin-left: 20%;

        .subTitle {
          color: rgba(110, 110, 115, 1);
          font-size: 16px;
          font-family: SourceHanSansCN-Regular;
          font-weight: normal;
          text-align: left;
          line-height: 24px;
          margin-left: 12.5%;
        }

        .subTitle-list {
          line-height: 30px;
          color: #999;
          cursor: pointer;
          margin-left: 12.5%;

          p {
            text-align: left; /* 确保文字左对齐 */
            // padding-left: 10px; /* 可选：增加左边距，让文本与输入框保持一致 */
            font-size: 16px; /* 可选：调整字体大小，使其与设计匹配 */
            margin: 0; /* 清除默认的外边距 */
            font-family: SourceHanSansCN-Medium;
            font-weight: 600;
            line-height: 36px;
          }

          p:hover {
            text-align: left; /* 确保文字左对齐 */
            // padding-left: 10px; /* 可选：增加左边距，让文本与输入框保持一致 */
            font-size: 16px; /* 可选：调整字体大小，使其与设计匹配 */
            margin: 0; /* 清除默认的外边距 */
            color: rgba(0, 112, 255, 1);
            font-family: SourceHanSansCN-Medium;
            font-weight: 600;
            line-height: 36px;
          }
        }
      }
    }


  }

  .activeDiv {
    /*color: #1c31a2;*/
    color: #00AEEF
  }

  .notActiveDiv {
    color: #333333;
  }


  .sousuo-phone{
    display: none !important;
  }
}

/* ====== 移动端样式 (小于800px) ====== */
@media only screen and (max-width: 800px) {
  ._navcontainer {
    top: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: 0.75rem;
    height: 60px;
    min-height: 60px;
    background-color: rgb(51, 51, 51);
    color: rgb(214, 214, 214);
    position: relative;
    padding: 0 1rem;

    ._appleicon {
      flex-shrink: 0;
    }

    .sousuo-phone {
      order: 2;
      margin-left: auto;
    }

    ._navicon {
      order: 3;
      width: 60px;
      display: flex;
      justify-content: center;
    }
    .iconfont {
      font-size: 24px;
    }

    ._appleicon {
      width: 120px;
      flex-shrink: 0;
    }

    ._mainnavlist {
      display: flex;
      flex-direction: column;
      position: absolute;
      //屏幕宽度小于800，默认清空下菜单是关闭的
      display: none;
      position: fixed;
      left: 0;
      top: 0 !important;
      z-index: 1999 !important;
      padding-top: 40px !important;
      width: 100%;
      height: 100%;
      color: rgb(214, 214, 214);
      background-color: rgba(0, 0, 0, 0.95);
      top: 40px;
      padding: 0 40px;
      z-index: 999;

      div {
        text-align: center;
        height: 40px;
        line-height: 40px;
        width: 100%;
        border-bottom: 1px solid rgb(214, 214, 214);
      }

      .languageButBox {
        position: relative;
        left: 0 !important;
        top: 2%;
        width: 100% !important;
        display: flex;
        justify-content: center;
        margin-top: 20px !important;

        img {
          width: 30% !important;
        }
      }
    }

    .shopcar {
      width: 100px;
    }
  }
  .sousuo-phone{
    position: static;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
  }
  .nav-actions {
    order: 4;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-left: 0;
  }
  .sousuo {
    display: none !important;
  }
  .dropdown {
    display: none !important;
  }

  .navlistshow {
    display: block !important;
  }

  .activeDiv {
    color: #1c31a2;
  }

  .notActiveDiv {
    color: rgb(214, 214, 214);
  }

  .languagecontainer {
    width: 96%;
    height: 2em;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
    margin-bottom: 20px;
  }

  .languageline {
    width: 500px;
    height: 1px;
    justify-content: center;
    background-color: #111111;
  }

  .languageChange {
    width: 8em;
    height: 100%;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    font-size: 14px;
    border: 1px solid #111111;
    border-radius: 10px;
  }
}

/* ====== 粘性导航栏样式 ====== */
.sticky-nav {
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

/* ====== 下拉箭头样式 ====== */
.dropdown-arrow {
  display: inline-block;
  margin-left: 1px;
  font-size: 0.8em;
  transition: transform 0.3s ease;
}

// Rotate arrow when dropdown is open
.activeDiv .dropdown-arrow {
  transform: rotate(180deg);
}

/* ====== 语言切换器样式 ====== */
.language-dropdown-container {
  position: relative;
  display: inline-block;
}

.languageButBox-wrapper {
  cursor: pointer;
}

.language-dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  min-width: 120px;
  z-index: 1001;
  color: #1e1f1b;
}

.language-dropdown-menu:hover {
  color: #626360 !important;
}

.language-option {
  padding: 10px 15px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.language-option:hover {
  color: #626360 !important;
  background-color: #dfdfe3;
}

.language-selector {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0.5rem 0.8rem;
  border-radius: 6px;
  font-size: clamp(12px, 1.6vh, 16px);
  transition: background-color 0.3s ease;
}

.language-selector:hover {
  background-color: rgba(0, 174, 239, 0.1);
}

.language-icon {
  display: flex;
  align-items: center;
  margin-right: 0.4rem;
}

.language-text {
  font-size: clamp(12px, 1.6vh, 16px);
  display: flex;
  align-items: center;
  font-weight: 500;
  margin-right: 0.3rem;
}

</style>



// WEBPACK FOOTER //
// src/components/comcomponents/NavTop2.vue